// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"243":"recruitment","809":"users","983":"products"}[chunkId] + "." + {"243":"bfca9e56","809":"3552e789","983":"1d5a1db0"}[chunkId] + ".css";
};